export const getFallbackLocation = () => ({
    // Coordinates for Johannesburg, South Africa
    latitude: -26.2041,
    longitude: 28.0473,
    origin: 'fallback',
});
//# sourceMappingURL=getFallbackLocation.js.map